module.exports = __webpack_public_path__ + "static/img/bird2.e67c032.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird2.gif
// module id = KEcb
// module chunks = 1